import script from "./Log.vue?vue&type=script&setup=true&lang=js"
export * from "./Log.vue?vue&type=script&setup=true&lang=js"

import "./Log.vue?vue&type=style&index=0&id=530caef2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-530caef2"]])

export default __exports__